type Mutex = {
  locked: boolean;
  lock: () => void;
  unlock: () => void;
};

type ZolaMutexes = {
  mutexes: Record<string, Mutex>;
};

/**
 * Gets a globally accessible mutex object
 *
 * @example
 * mutex = getMutex('some-mutex')
 * mutex.locked // Checks whether the mutex is locked
 * mutex.lock() // Locks the mutex
 * mutex.unlock() // Unlocks the mutex
 */
export const getMutex = (key: string): Mutex => {
  if (!window.zola) {
    window.zola = {};
  }

  const zola = window.zola as ZolaMutexes;

  if (!zola.mutexes) {
    zola.mutexes = {};
  }

  if (zola.mutexes[key] === undefined) {
    zola.mutexes[key] = {
      locked: false,
      lock: () => {
        zola.mutexes[key].locked = true;
      },
      unlock: () => {
        zola.mutexes[key].locked = false;
      },
    };
  }

  return zola.mutexes[key];
};
